// Sessão do parceiro: quando a resposta da API significa "faça login de novo".

export const LOGIN_PATH = "/default-login";

// 401 em qualquer rota, exceto o próprio login (lá 401 = senha errada, não sessão vencida).
export function isSessionExpired(error) {
  const res = error && error.response;
  if (!res || res.status !== 401) return false;
  const url = String((error.config && error.config.url) || "");
  return !/\/access\/login/.test(url);
}

export function clearSession(storage = window.localStorage) {
  try {
    storage.removeItem("auth");
  } catch (e) {
    /* storage bloqueado: nada a limpar */
  }
}
